import { useState, useEffect } from 'react';

/**
 * Custom hook për debouncing values
 * 
 * @param {*} value - Vlera që duhet debounced
 * @param {number} delay - Delay në milliseconds (default: 500ms)
 * @returns {*} - Debounced value
 */
export const useDebounce = (value, delay = 500) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};





